var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// eslint-disable-next-line no-unused-vars
import { gql, ApolloClient } from '@apollo/client';
var PRODUCT_BY_HANDLE = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query productByHandle($handle: String!) {\n    product(handle: $handle) {\n      id\n      title\n      tags\n      sellingPlanGroups(first: 1) { # there's only ever one selling plan group right now\n        edges {\n          node {\n            name\n            sellingPlans(first: 10) {\n              edges {\n                node {\n                  id\n                  name\n                  description\n                  checkoutCharge {\n                    value {\n                      ...on MoneyV2 {\n                        amount\n                        currencyCode\n                      }\n                      ...on SellingPlanCheckoutChargePercentageValue {\n                        percentage\n                      }\n                    }\n                  }\n                  options {\n                    name\n                    value\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      variants(first: 10) {\n        edges {\n          node {\n            id\n            sku\n            title\n            # position??\n            availableForSale\n            priceV2 {\n              amount\n              currencyCode\n            }\n            metafields(identifiers: [{namespace: \"global\", key: \"SoldOut\"}]) {\n              namespace\n              key\n              value\n            }\n            image {\n              id\n              url(transform: {maxWidth: 150})\n              height\n              width\n              altText\n            }\n            sellingPlanAllocations(first:10) {\n              edges {\n                node {\n                  sellingPlan {\n                    id\n                    priceAdjustments {\n                      adjustmentValue {\n                        ...on SellingPlanPercentagePriceAdjustment {\n                          adjustmentPercentage\n                        }\n                        ...on SellingPlanFixedAmountPriceAdjustment {\n                          adjustmentAmount {\n                            amount\n                          }\n                        }\n                        ...on SellingPlanFixedPriceAdjustment {\n                          price {\n                            amount\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }            \n          }\n        }\n      }\n    }\n  }\n"])));
/**
 *
 * @param {ApolloClient} client
 * @param {string} handle
 *
 * @return {Promise<{id: string, title: string, tags: string[], sellingPlanGroups: Object[], variants: Object[]}>}
 */

export function queryProductByHandle(_x, _x2) {
  return _queryProductByHandle.apply(this, arguments);
}

function _queryProductByHandle() {
  _queryProductByHandle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(client, handle) {
    var result, _result$data, _result$data$product, product, id, title, tags, sellingPlanGroupNodes, variantNodes, sellingPlanGroups;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.query({
              query: PRODUCT_BY_HANDLE,
              variables: {
                handle: handle
              }
            });

          case 2:
            result = _context.sent;
            _result$data = result.data;
            _result$data = _result$data === void 0 ? {} : _result$data;
            _result$data$product = _result$data.product, product = _result$data$product === void 0 ? {} : _result$data$product;

            if (!(product == null)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", null);

          case 8:
            id = product.id, title = product.title, tags = product.tags, sellingPlanGroupNodes = product.sellingPlanGroups.edges, variantNodes = product.variants.edges;
            sellingPlanGroups = sellingPlanGroupNodes.map(function (grp) {
              return grp.node;
            }).map(function (grp) {
              return _objectSpread(_objectSpread({}, grp), {}, {
                sellingPlans: grp.sellingPlans.edges.map(function (edg) {
                  return edg.node;
                })
              });
            });
            return _context.abrupt("return", {
              id: id,
              title: title,
              tags: tags,
              sellingPlanGroups: sellingPlanGroups,
              variants: variantNodes.map(function (vnt) {
                return _objectSpread(_objectSpread({}, vnt.node), {}, {
                  // eslint-disable-next-line camelcase
                  featured_image_thumbnail: _objectSpread(_objectSpread({}, vnt.node.image), {}, {
                    src: vnt.node.image.url,
                    alt: vnt.node.image.altText
                  }),
                  sellingPlanAllocations: vnt.node.sellingPlanAllocations.edges.map(function (edg) {
                    var _edg$node;

                    return edg === null || edg === void 0 ? void 0 : (_edg$node = edg.node) === null || _edg$node === void 0 ? void 0 : _edg$node.sellingPlan;
                  })
                });
              })
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _queryProductByHandle.apply(this, arguments);
}